const TWENTY_FOUR_HOURS_MS = 24 * 60 * 60 * 1000;

/**
 * Calculates the number of full days since the user's last inbound message.
 * Returns null if lastMessageAt is missing or invalid.
 */
export function getInactivityDays(
  lastMessageAt: string | null | undefined,
  currentTime: Date = new Date()
): number | null {
  if (!lastMessageAt) {
    return null;
  }

  const lastMessageTime = new Date(lastMessageAt);
  const lastMessageTimestamp = lastMessageTime.getTime();

  if (Number.isNaN(lastMessageTimestamp)) {
    return null;
  }

  const timeDiffMs = currentTime.getTime() - lastMessageTimestamp;
  if (timeDiffMs < 0) {
    return null;
  }

  return Math.floor(timeDiffMs / TWENTY_FOUR_HOURS_MS);
}
